import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './style.css';

const AsoValidarTelefone = () => {
    const Navigate = useNavigate();
    const location = useLocation();
    const { dbName } = useParams();

    return (
        <div className="redirect__container2">
            <div className="generic-layout__container2">
                <div className="layout-mp__top-container2">
                    <div className="layout-mp__title2" id="layout-title">
                        <div className="layout-mp__title_text2">Termine a Validação pelo seu celular.</div>
                    </div>
                    <div className="layout-mp__main-container2">
                        <div className="redirect__page-container2">
                            <div className="landing__container2">
                                <img className="landing__image selfie__image2" src="https://http2.mlstatic.com/storage/identity-validation-mobile-api/images/web/MP/handoff_mp.svg" />
                                <div className="landing__title2">Termine a validação pelo seu celular.</div>
                                <div className="landing__text2">Você receberá um token por WhatsApp para continuar.</div>
                                <div className="landing__actions2">
                                    <div className="component__actions_vertical2 component__actions_mp_desktop2">
                                        <span>
                                            <form>
                                                <button type="button" className="andes-button2 andes-button--large2 andes-button--loud2" onClick={() => {Navigate(location.pathname === `/aso/registro/validar-telefone-aso/${dbName}` ? `/aso/registro/disparo-sms-aso/${dbName}` : `/aso/registro/disparo-sms/${dbName}`)}}>
                                                    <span className="andes-button__content2">
                                                        <span className="andes-button__text2">Continuar</span>
                                                    </span>
                                                </button>
                                            </form>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AsoValidarTelefone;